import { getPlayerById, getTeamInfoById, getVisualTimer } from "../../../../../../../sports/genericUtils.js"
import GenericScore from "../generic/GenericScore.js";


const BasketPoint = ({item, match, icon}) => {

    const {text, title, team, player, period, timer} = item.detail
    
    const visualTimer = getVisualTimer(timer, period, match.discipline)
    const teamDetail = getTeamInfoById(team, match)
    const playerDetail = getPlayerById(player, match)

    return (
      <GenericScore 
        teamDetail={teamDetail} 
        playerDetail={playerDetail} 
        visualTimer={visualTimer} 
        icon={icon}
        title={title}
        text={text}
      />
      );
}

export default BasketPoint